import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      category_id: '',
      loadConfig,
      isLock: false,
      list: {},
      category_list: [],
      popMineTaskShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/mine/task", {
        category_id: this.category_id
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data;
      }
    },
    async onCreate() {
      this.modifyData = {
        "icon": "",
        'status': "1",
        "sort": "0",
        "pre_type": 0
      };
      this.popMineTaskShow = true;
    },
    async onModify(item) {
      this.modifyData = item;
      this.popMineTaskShow = true;
    },
    async onRemove(item) {
      this.isLoading = true;
      let rs = await this.$http.post("/mine/task/remove", {
        id: item.id
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data;
      }
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onChange(e) {
      this.category_id = e;
    }
  },
  async mounted() {
    this.category_id = this.$route.query.id || '';
    let rs = await this.$http.post("/mine/category", {});
    if (rs.code == 0) {
      this.category_list = rs.data;
    }
    this.getData();
  }
};